import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import React, { useState } from "react";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
import { useTranslation } from "@i18n";
import { useDhamenContext } from "@/common/Contexts/DhamenContextProvider";
import { api__respondToDhamenOffer } from "@/pages/checkout/dhamen/api";
import { toast } from "sonner";
import useBoolean from "@hooks/useBoolean";
import InfoModal from "@/pages/checkout/dhamen/components/common/InfoModal";
import { handleGtmEvent } from "@/common/events/gtmEvents";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import OfferIcon from "@/pages/checkout/dhamen/icons/OfferIcon";
import ReusableBtn from "@/pages/checkout/bnpl/common/components/ReusableBtn";
import useHelpers from "@hooks/useHelpers";
import { DHAMEN_STATUS } from "@/pages/checkout/dhamen/constants";
import Countdown from "react-countdown";
import stl from "@/pages/checkout/finance-checkout/FreeFinanceFormPage.module.css";
import SAR from "@componentsShared/SAR/SAR";
import WarningIcon from "@/pages/checkout/dhamen/icons/WarningIcon";
var InitialOfferScreen = function InitialOfferScreen() {
  var _data$financing_detai, _state$orderInfo;
  var _useDhamenContext = useDhamenContext(),
    state = _useDhamenContext.state,
    actions = _useDhamenContext.actions;
  var _useState = useState(false),
    isSubmitting = _useState[0],
    setIsSubmitting = _useState[1];
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var rejectModal = useBoolean();
  var data = state === null || state === void 0 ? void 0 : state.orderInfo;
  var isMobile = useIsMobile();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;

  // Extract offer expiry date and set countdown
  var offerExpiryDate = data === null || data === void 0 ? void 0 : (_data$financing_detai = data.financing_details) === null || _data$financing_detai === void 0 ? void 0 : _data$financing_detai.offer_expiry_date;

  // Calculate countdown date - always use a future date for testing
  var countdownDate = React.useMemo(function () {
    if (offerExpiryDate) {
      // Try to parse the date - handle different formats
      var parsedDate = new Date(offerExpiryDate);
      if (!isNaN(parsedDate.getTime()) && parsedDate.getTime() > Date.now()) {
        console.log("Using offer expiry date:", parsedDate);
        return parsedDate.getTime();
      }
    }
  }, [offerExpiryDate]);
  var financingDetails = (_state$orderInfo = state.orderInfo) === null || _state$orderInfo === void 0 ? void 0 : _state$orderInfo.financing_details;

  // Handle offer response
  var handleOfferResponse = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(responseStatus) {
      var _state$orderInfo2, _state$orderInfo2$ord, _state$orderInfo3, _state$orderInfo3$ord, _state$orderInfo4, _state$orderInfo4$ord, _state$orderInfo5, _state$orderInfo5$ord, _state$orderInfo5$ord2, _state$orderInfo6, _state$orderInfo6$fin, _state$orderInfo7, _state$orderInfo7$fin, _state$orderInfo8, _state$orderInfo8$fin, response, message, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            setIsSubmitting(true);
            _context.n = 1;
            return api__respondToDhamenOffer({
              uuid: state.orderInfo.uuid,
              response_status: responseStatus
            });
          case 1:
            response = _context.v;
            handleGtmEvent("dhamen_order_submit", {
              order_id: state === null || state === void 0 ? void 0 : (_state$orderInfo2 = state.orderInfo) === null || _state$orderInfo2 === void 0 ? void 0 : (_state$orderInfo2$ord = _state$orderInfo2.order) === null || _state$orderInfo2$ord === void 0 ? void 0 : _state$orderInfo2$ord.id,
              post_id: state === null || state === void 0 ? void 0 : (_state$orderInfo3 = state.orderInfo) === null || _state$orderInfo3 === void 0 ? void 0 : (_state$orderInfo3$ord = _state$orderInfo3.order) === null || _state$orderInfo3$ord === void 0 ? void 0 : _state$orderInfo3$ord.post_id,
              transaction_id: state === null || state === void 0 ? void 0 : (_state$orderInfo4 = state.orderInfo) === null || _state$orderInfo4 === void 0 ? void 0 : (_state$orderInfo4$ord = _state$orderInfo4.order) === null || _state$orderInfo4$ord === void 0 ? void 0 : _state$orderInfo4$ord.order_uuid,
              post_price: state === null || state === void 0 ? void 0 : (_state$orderInfo5 = state.orderInfo) === null || _state$orderInfo5 === void 0 ? void 0 : (_state$orderInfo5$ord = _state$orderInfo5.order) === null || _state$orderInfo5$ord === void 0 ? void 0 : (_state$orderInfo5$ord2 = _state$orderInfo5$ord.pricing) === null || _state$orderInfo5$ord2 === void 0 ? void 0 : _state$orderInfo5$ord2.total_price,
              platform: getPlatformInfo(),
              salary: state === null || state === void 0 ? void 0 : (_state$orderInfo6 = state.orderInfo) === null || _state$orderInfo6 === void 0 ? void 0 : (_state$orderInfo6$fin = _state$orderInfo6.financing_details) === null || _state$orderInfo6$fin === void 0 ? void 0 : _state$orderInfo6$fin.requested_monthly_income,
              // todo
              monthly_commitments: state === null || state === void 0 ? void 0 : (_state$orderInfo7 = state.orderInfo) === null || _state$orderInfo7 === void 0 ? void 0 : (_state$orderInfo7$fin = _state$orderInfo7.financing_details) === null || _state$orderInfo7$fin === void 0 ? void 0 : _state$orderInfo7$fin.requested_monthly_commitments,
              first_payment: state === null || state === void 0 ? void 0 : (_state$orderInfo8 = state.orderInfo) === null || _state$orderInfo8 === void 0 ? void 0 : (_state$orderInfo8$fin = _state$orderInfo8.financing_details) === null || _state$orderInfo8$fin === void 0 ? void 0 : _state$orderInfo8$fin.requested_first_payment,
              financing_duration: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.contract_term_years,
              requested_financing_amount: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.requested_financing_amount,
              approved_financing_amount: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.financing_amount,
              fees_vat: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.admin_fees,
              APR: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.apr,
              monthly_installment: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.monthly_installment,
              customer_action: responseStatus.toLocaleLowerCase()
            });
            if (response.success) {
              message = responseStatus === "APPROVED" ? "تم قبول العرض بنجاح" : "تم رفض العرض";
              toast.success(message, {
                position: "bottom-center",
                duration: 3000
              });
              actions.updateFinancingDetails({
                quote_no: response.data.quote_no,
                url: response.data.url
              });
              responseStatus === "APPROVED" ? actions.setStatus(DHAMEN_STATUS.ACCEPTED_ACTION) : actions.setStatus(DHAMEN_STATUS.DECLINED_ACTION);
            } else {
              toast.error(response.errors || "حدث خطأ في معالجة الطلب", {
                position: "bottom-center",
                duration: 5000
              });
            }
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error("Error responding to offer:", _t);
            toast.error("حدث خطأ في الاتصال. يرجى المحاولة مرة أخرى.", {
              position: "bottom-center",
              duration: 5000
            });
          case 3:
            _context.p = 3;
            setIsSubmitting(false);
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2, 3, 4]]);
    }));
    return function handleOfferResponse(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleEditOffer = function handleEditOffer() {
    var _state$orderInfo9, _state$orderInfo9$ord, _state$orderInfo0, _state$orderInfo0$ord, _state$orderInfo1, _state$orderInfo1$ord, _state$orderInfo10, _state$orderInfo10$or, _state$orderInfo10$or2, _state$orderInfo11, _state$orderInfo11$fi, _state$orderInfo12, _state$orderInfo12$fi, _state$orderInfo13, _state$orderInfo13$fi;
    handleGtmEvent("dhamen_offer_revise", {
      order_id: state === null || state === void 0 ? void 0 : (_state$orderInfo9 = state.orderInfo) === null || _state$orderInfo9 === void 0 ? void 0 : (_state$orderInfo9$ord = _state$orderInfo9.order) === null || _state$orderInfo9$ord === void 0 ? void 0 : _state$orderInfo9$ord.id,
      post_id: state === null || state === void 0 ? void 0 : (_state$orderInfo0 = state.orderInfo) === null || _state$orderInfo0 === void 0 ? void 0 : (_state$orderInfo0$ord = _state$orderInfo0.order) === null || _state$orderInfo0$ord === void 0 ? void 0 : _state$orderInfo0$ord.post_id,
      transaction_id: state === null || state === void 0 ? void 0 : (_state$orderInfo1 = state.orderInfo) === null || _state$orderInfo1 === void 0 ? void 0 : (_state$orderInfo1$ord = _state$orderInfo1.order) === null || _state$orderInfo1$ord === void 0 ? void 0 : _state$orderInfo1$ord.order_uuid,
      post_price: state === null || state === void 0 ? void 0 : (_state$orderInfo10 = state.orderInfo) === null || _state$orderInfo10 === void 0 ? void 0 : (_state$orderInfo10$or = _state$orderInfo10.order) === null || _state$orderInfo10$or === void 0 ? void 0 : (_state$orderInfo10$or2 = _state$orderInfo10$or.pricing) === null || _state$orderInfo10$or2 === void 0 ? void 0 : _state$orderInfo10$or2.total_price,
      platform: getPlatformInfo(),
      salary: state === null || state === void 0 ? void 0 : (_state$orderInfo11 = state.orderInfo) === null || _state$orderInfo11 === void 0 ? void 0 : (_state$orderInfo11$fi = _state$orderInfo11.financing_details) === null || _state$orderInfo11$fi === void 0 ? void 0 : _state$orderInfo11$fi.requested_monthly_income,
      // todo
      monthly_commitments: state === null || state === void 0 ? void 0 : (_state$orderInfo12 = state.orderInfo) === null || _state$orderInfo12 === void 0 ? void 0 : (_state$orderInfo12$fi = _state$orderInfo12.financing_details) === null || _state$orderInfo12$fi === void 0 ? void 0 : _state$orderInfo12$fi.requested_monthly_commitments,
      first_payment: state === null || state === void 0 ? void 0 : (_state$orderInfo13 = state.orderInfo) === null || _state$orderInfo13 === void 0 ? void 0 : (_state$orderInfo13$fi = _state$orderInfo13.financing_details) === null || _state$orderInfo13$fi === void 0 ? void 0 : _state$orderInfo13$fi.requested_first_payment,
      financing_duration: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.contract_term_years,
      requested_financing_amount: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.requested_financing_amount,
      approved_financing_amount: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.financing_amount,
      fees_vat: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.admin_fees,
      APR: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.apr,
      monthly_installment: state === null || state === void 0 ? void 0 : state.orderInfo.financing_details.monthly_installment
    });
    navigateTo("/site/dhamen/".concat(state === null || state === void 0 ? void 0 : state.orderInfo.uuid, "?tab=finance-form&status=").concat(DHAMEN_STATUS.REVISED));
    actions.setStatus(DHAMEN_STATUS.REVISED);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-0 bg-gray-50 w-full md:min-h-screen "
  }, !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "flex  py-8 md:min-w-[560px]  w-full max-w-md mx-auto "
  }, /*#__PURE__*/React.createElement("button", {
    className: ["whtBtn", stl.backBtn].join(" "),
    onClick: actions.handleBackClick
  }, tShort("dhamen/back"))), /*#__PURE__*/React.createElement("div", {
    className: "h-full bg-gray-50 flex items-center justify-center md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full max-w-md flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:bg-white md:rounded-2xl md:shadow-sm md:border md:border-gray-100 p-6 md:p-12 md:min-w-[560px]"
  }, !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center p-4"
  }, /*#__PURE__*/React.createElement(OfferIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-2xl font-bold text-[#154F9C] text-center mt-10 mb-4"
  }, tShort("dhamen/initial_offer_main_title")), offerExpiryDate && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center gap-2 text-[#6C7A8D] mb-8"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--nest-clock-farsight-analog-outline",
    width: 6,
    height: 6,
    className: "text-[#FE561C]"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-[16px]"
  }, tShort("dhamen/offer_available_for"), " ", /*#__PURE__*/React.createElement(Countdown, {
    key: countdownDate,
    date: countdownDate,
    onComplete: function onComplete() {},
    renderer: function renderer(_ref2) {
      var hours = _ref2.hours,
        minutes = _ref2.minutes,
        seconds = _ref2.seconds,
        days = _ref2.days,
        completed = _ref2.completed;
      if (completed) {
        return /*#__PURE__*/React.createElement("span", {
          className: "font-bold text-[#FE561C]"
        }, "00:00:00");
      }

      // Calculate total hours including days
      var totalHours = days * 24 + hours;
      return /*#__PURE__*/React.createElement("span", {
        className: "font-bold text-[#FE561C]"
      }, totalHours < 10 ? "0".concat(totalHours) : totalHours, ":", minutes < 10 ? "0".concat(minutes) : minutes, ":", seconds < 10 ? "0".concat(seconds) : seconds);
    }
  }), " ", tShort("dhamen/hours_only"))), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-bold text-gray-800 mt-10 mb-4 text-[16px] md:text-[20px]"
  }, tShort("dhamen/offer_details_section")), /*#__PURE__*/React.createElement("div", {
    className: "border  border-[#d6dfe9] border-[0px_0px_1px] border-solid rounded-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] md:text-[16px] flex justify-between items-center py-3 px-2 border-b border-[#d6dfe9] border-[0px_0px_1px] border-solid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-700 font-bold"
  }, tShort("dhamen/financing_amount")), /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold text-[14px] md:text-[18px]"
  }, financingDetails === null || financingDetails === void 0 ? void 0 : financingDetails.financing_amount, " SAR")), /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] md:text-[16px] flex justify-between items-center py-3 px-2 border-b border-[#d6dfe9] border-[0px_0px_1px] border-solid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-700 font-bold"
  }, tShort("dhamen/admin_fees_vat")), /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold text-[14px] md:text-[18px]"
  }, financingDetails === null || financingDetails === void 0 ? void 0 : financingDetails.admin_fees, " SAR")), /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] md:text-[16px] flex justify-between items-center py-3 px-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-700 font-bold"
  }, tShort("dhamen/contract_duration")), /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold  text-[14px] md:text-[18px]"
  }, financingDetails === null || financingDetails === void 0 ? void 0 : financingDetails.contract_term_years, " ", tShort("dhamen/years"))), /*#__PURE__*/React.createElement("div", {
    className: "bg-blue-50 p-6 text-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-xs md:text-[16px] text-[#154F9C] font-bold mb-2"
  }, tShort("dhamen/monthly_installment_label")), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center gap-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-5xl font-bold text-[#154F9C]"
  }, financingDetails === null || financingDetails === void 0 ? void 0 : financingDetails.monthly_installment), /*#__PURE__*/React.createElement("span", {
    className: "text-[14px] font-bold md:text-lg text-[#154F9C] flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(SAR, {
    className: "text-2xl"
  }), " ", /*#__PURE__*/React.createElement("span", null, "/ ", tShort("dhamen/month")))), /*#__PURE__*/React.createElement("p", {
    className: "text-xs text-[#6C7A8D] mt-2"
  }, tShort("dhamen/preliminary_price"))))), /*#__PURE__*/React.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/React.createElement(ReusableBtn, {
    label: tShort("dhamen/approve_submit_request"),
    onClick: function onClick() {
      return handleOfferResponse("APPROVED");
    },
    variant: "fill",
    isLoading: isSubmitting,
    disabled: isSubmitting
  }), /*#__PURE__*/React.createElement(ReusableBtn, {
    label: tShort("dhamen/edit_request_data"),
    onClick: handleEditOffer,
    variant: "outline"
  }), /*#__PURE__*/React.createElement(ReusableBtn, {
    label: tShort("dhamen/not_approved"),
    onClick: function onClick() {
      return rejectModal.setTrue();
    },
    variant: "custom",
    textColor: "#D83434",
    borderColor: "#fff"
  })))))), /*#__PURE__*/React.createElement(InfoModal, {
    icon: /*#__PURE__*/React.createElement(WarningIcon, null),
    open: rejectModal.value,
    onClose: rejectModal.setFalse,
    toggle: rejectModal.toggle,
    title: tShort("dhamen/confirm_reject_financing_offer"),
    text: tShort("dhamen/reject_not_required"),
    primaryButton: {
      label: tShort("dhamen/edit_request_data"),
      onClick: handleEditOffer
    },
    confirmationButton: {
      label: tShort("dhamen/reject_financing_offer"),
      onClick: function onClick() {
        handleOfferResponse("REJECTED");
      }
    }
  })));
};
export default InitialOfferScreen;